import React, { useState, useEffect } from "react";

import Calendar from "./Calendar";
import UsePeritajes from "./hooks/UsePeritajes";
import Uploader from "./Uploader";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import LoaderModal from "../modals/LoaderModal";

import { DateTime } from "luxon";

export default function Peritajes({ hash }) {
  const [selection, setSelection] = useState(null);

  const {
    clientData,
    handleUpload,
    handleFilesChange,
    handleDeleteFile,
    files,
    showLoader,
    isExpired,
  } = UsePeritajes(hash, selection);
  const [spinner, setSpinner] = useState(false);

  const rowStyle = "m-0 p-0";

  const [informativeText, setInformativeText] = useState("");

  const handleCotizar = () => {
    window.location = "https://store.autoprana.com.ar/cotizador";
  };

  let welcomeMessage = (
    <span>
      <h2>
        Hola {clientData.Nombre} {clientData.Apellido}, <br></br> Bienvenido a
        nuestro modulo de compra de usados!
      </h2>
    </span>
  );

  let bodyMessage = isExpired ? (
    <>
      <span>
        Tu cotización ya expiró. Te invitamos a realizarla nuevamente.
      </span>
      <Row className={(rowStyle, "justify-content-center mb-5")}>
        <Col xs={12} md={2} className="text-center pt-4">
          <Button onClick={handleCotizar}>Cotizar</Button>
        </Col>
      </Row>
    </>
  ) : (
    <span>
      Para continuar con la venta de tu {clientData.Marca}
      {clientData.Version} <br></br> selecciona la fecha y hora para realizar la
      inspección técnica de tu vehículo.
    </span>
  );

  const handleSelection = (selectionParam) => {
    let date = DateTime.fromJSDate(new Date(selectionParam)).toFormat(
      "yyyy-MM-dd HH:mm:00"
    );
    setSelection(date);
  };

  useEffect(() => {
    clientData.length !== 0 && setSpinner(true);
  }, [clientData]);

  useEffect(() => {
    selectionInstructions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selection]);

  const selectionInstructions = () => {
    switch (true) {
      case selection === null:
        setInformativeText("Selecciona la fecha");
        break;
      case selection && selection.indexOf("00:00") !== -1:
        setInformativeText("Ahora, elegí un horario");
        break;
      case selection && selection.indexOf("00:00") === -1:
        setInformativeText(<span>Seleccionaste: {selection}</span>);
        break;

      default:
        break;
    }
  };

  return spinner ? (
    <>
      <Container style={{ backgroundColor: "white" }}>
        <Row className={rowStyle}>
          <Col xs={12} className="mb-3 text-center mt-4">
            <Card className="shadow-lg" bg="light">
              <Card.Header style={{ fontSize: "23px" }}>
                <img
                  src="https://store.autoprana.com.ar/img/imgSitio/logos/logoBig.png"
                  width="200px"
                  alt="logo empresa"
                  className="pt-1"
                ></img>
              </Card.Header>
              <Card.Body>
                <Card.Title className="p-3">{welcomeMessage} </Card.Title>
                <Card.Text className="pb-3" style={{ fontSize: "18px" }}>
                  {bodyMessage}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {!isExpired && (
          <>
            <Row className={rowStyle}>
              <Col className="text-center">
                <h4>{informativeText}</h4>
              </Col>
            </Row>
            <Row className={rowStyle}>
              <Col className="mt-2 p-0">
                <Calendar onHandleSelection={handleSelection} />
              </Col>
            </Row>
            <Row className={rowStyle}>
              <Col className="mt-3 p-0 text-center">
                <h4>
                  Subí una foto de tu vehículo como se muestra en el ejemplo
                </h4>
              </Col>
            </Row>
            <Row className={rowStyle}>
              <Col className="text-center">
                <img
                  src="https://store.autoprana.com.ar/cotizador/img/car.png"
                  width="240px"
                  alt="ejemple de foto"
                ></img>
              </Col>
            </Row>
            <Row className={(rowStyle, "justify-content-center")}>
              <Col xs={12} md={2} className="text-center">
                <Uploader
                  handleUpload={handleUpload}
                  handleFilesChange={handleFilesChange}
                  handleDeleteFile={handleDeleteFile}
                  files={files}
                />
              </Col>
            </Row>
            <Row className={(rowStyle, "justify-content-center mb-5")}>
              <Col xs={12} md={2} className="text-center pt-4">
                <Button onClick={handleUpload}>Confirmar</Button>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <footer className="bg-light text-center text-lg-start">
        <div
          className="text-center p-3 pb-4"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
        >
          © 2021 Copyright <b>Prana</b>
        </div>
      </footer>

      <LoaderModal show={showLoader} />
    </>
  ) : (
    <>
      <Row className="mx-0" style={{ marginTop: "15rem" }}>
        <Col className="text-center m-0 p-0">
          <Spinner animation="grow" variant="secondary" />
        </Col>
      </Row>
      <Row className="m-0 p-0">
        <Col className="text-center">Cargando...</Col>
      </Row>
    </>
  );
}
